// @flow

import React from 'react';
import { Cookies, withCookies } from 'react-cookie';
import { surfaceConvertor } from '../../utils/currencyConvertorUtils';

type Props = {
  value: number,
  cookies: Cookies,
  isBold?: boolean,
  className?: ?string,
}

class SurfaceConvertor extends React.Component<Props> {
  static defaultProps = {
    isBold: false,
    className: null,
  };

  render() {
    return (
      <div
        className={`currency-convertor ${this.props.isBold ? 'bold' : ''} ${this.props.className ? this.props.className : ''}`}
      >
        {surfaceConvertor(this.props.value, this.props.cookies)}
      </div>
    );
  }
}

export default withCookies(SurfaceConvertor);
